import { render, staticRenderFns } from "./EditDataObjectDialog.vue?vue&type=template&id=3232eda2&scoped=true&"
import script from "./EditDataObjectDialog.vue?vue&type=script&lang=js&"
export * from "./EditDataObjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3232eda2",
  null
  
)

export default component.exports